import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Star } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    num: '1',
    title: 'Fundamentos del Entrenamiento Funcional',
    desc: 'Los 7 patrones de movimiento, estructura de clase profesional, calentamiento, progresión de niveles y glosario completo.'
  }, {
    num: '2',
    title: 'Banco de WODs y Rutinas Cross Training',
    desc: '50 WODs completos listos para dar: AMRAP, EMOM, For Time, Tabata y formatos especiales. Todos los niveles.'
  }, {
    num: '3',
    title: 'HIIT & ABS: Protocolos Completos',
    desc: '18 protocolos HIIT, 10 rutinas ABS funcional y 8 clases combinadas listas. De inicial a avanzado.'
  }, {
    num: '4',
    title: 'Programación Mensual y Anual',
    desc: 'Planes de 30, 60 y 90 días completos. 5 modelos de semana. Calendario anual. Nunca más improvisar la semana.'
  }, {
    num: '5',
    title: 'Entrenamiento por Objetivos',
    desc: 'Protocolos específicos para pérdida de grasa, fuerza funcional, resistencia y bienestar. Más poblaciones especiales.'
  }, {
    num: '⭐',
    title: 'Gestión y Crecimiento del Profe',
    desc: 'Precios, captación de alumnos, clases online, marca personal y plan de 12 meses para duplicar ingresos.',
    highlight: true
  }];
  const includes = ['Planificación lista para usar desde el primer día', 'WODs y protocolos con objetivo, desarrollo y cierre', 'Indicaciones técnicas listas para dar en clase', 'Variaciones Nivel Inicial, Intermedio y Avanzado por ejercicio', 'Checklist pre y durante la clase', 'Planillas de seguimiento de alumnos', 'Adaptaciones para grupos heterogéneos', '100% adaptado al entrenamiento funcional y cross training'];
  return <Section bg="dark-800" data-id="element-359">
      <div className="text-center mb-8 md:mb-16" data-id="element-360">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-3 md:mb-6" data-id="element-361">
          LOS 6 TOMOS
        </h2>
        <p className="text-base md:text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-362">
          Para profes de funcional y cross training de todos los niveles y
          enfoques
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12 md:mb-24" data-id="element-363">
        {tomos.map((tomo, i) => <div key={i} className={`relative p-5 md:p-8 rounded-2xl border ${tomo.highlight ? 'bg-gradient-to-b from-dark-800 to-dark-900 border-lime-500 shadow-[0_0_30px_rgba(204,255,0,0.1)]' : 'bg-dark-900 border-dark-700'}`} data-id="element-364">
            <div className={`absolute -top-5 md:-top-6 left-5 md:left-8 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center text-lg md:text-xl font-display font-bold border-4 border-dark-800 ${tomo.highlight ? 'bg-lime-500 text-dark-900' : 'bg-dark-700 text-lime-400'}`} data-id="element-365">
              {tomo.num}
            </div>

            <div className="mt-3 md:mt-4" data-id="element-366">
              <div className="text-xs md:text-sm font-bold tracking-widest uppercase mb-1 md:mb-2 text-gray-500" data-id="element-367">
                Tomo {tomo.num === '⭐' ? '6' : tomo.num}
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold text-white mb-2 md:mb-4 leading-snug" data-id="element-368">
                {tomo.title}
              </h3>
              <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-369">
                {tomo.desc}
              </p>
            </div>
          </div>)}
      </div>

      <div className="bg-dark-900 border border-dark-700 rounded-3xl p-5 md:p-12 max-w-4xl mx-auto" data-id="element-370">
        <h3 className="text-xl md:text-3xl font-display font-bold text-white text-center mb-6 md:mb-10" data-id="element-371">
          Cada tomo incluye:
        </h3>
        <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 md:gap-y-6" data-id="element-372">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-373">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-lime-500 flex-shrink-0 mt-0.5" data-id="element-374" />
              <span className="text-sm md:text-base text-gray-300 font-medium" data-id="element-375">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
}